import {
  Route,
  Routes as RouterDomRoutes,
  BrowserRouter,
} from 'react-router-dom';
import ProtectedRoute from 'components/common/ProtectedRoute';
import LoginPage from 'pages/login/LoginPage';
import ConfirmLoginPage from 'pages/login/ConfirmLoginPage';
import SendCodeForgotPassword from 'pages/login/SendCodeForgotPassword';
import ForgotPasswordCompletePage from 'pages/login/ForgotPasswordCompletePage';
import Cockpit from 'pages/cockpit/Cockpit';
import Thumbnails from 'pages/thumbnails/Thumbnails';
import Users from 'pages/users/Users';
import Units from 'pages/units/Units';
import Channels from 'pages/channels/Channels';
import Keywords from 'pages/keywords/Keywords';
import Videos from 'pages/videos/Videos';
import VideosHome from 'pages/VideosHome/VideosHome';
import SeriesHome from 'pages/SeriesHome/SeriesHome';
import CollectionsHomeNew from 'pages/CollectionsHomeNew/CollectionsHomeNew';
import VideosSteps from 'pages/videos/VideosSteps';
import SeriesSteps from 'pages/series/SeriesSteps';
import CollectionStepsNew from 'pages/collectionsNew/CollectionStepsNew';
import Personalities from 'pages/personalities/Personalities';
import Series from 'pages/series/Series';
import CollectionsNew from 'pages/collectionsNew/CollectionsNew';
import { MainLayout } from 'layouts/MainLayout';
import { SetupAppHome } from 'pages/SetupAppHome';
import { Example } from 'pages/Example';
import { ReportsHome } from 'pages/reports';

export const Routes = () => {
  return (
    <BrowserRouter>
      <RouterDomRoutes>
        {/* Protected routes (require auth) */}
        <Route element={<ProtectedRoute />}>
          {/* User route */}
          <Route
            path="/usuarios"
            element={
              <MainLayout>
                <Users />
              </MainLayout>
            }
          />

          {/* Cockpit route */}
          <Route
            path="/"
            element={
              <MainLayout>
                <Cockpit />
              </MainLayout>
            }
          />

          {/* Channel route */}
          <Route
            path="/unidades"
            element={
              <MainLayout>
                <Units />
              </MainLayout>
            }
          />
          <Route
            path="/canais"
            element={
              <MainLayout>
                <Channels />
              </MainLayout>
            }
          />

          <Route
            path="/personalidades"
            element={
              <MainLayout>
                <Personalities />
              </MainLayout>
            }
          />
          <Route
            path="/colecoesantigo"
            element={
              <MainLayout>
                <Series />
              </MainLayout>
            }
          />
          <Route
            path="/series/:id/:version/:action?"
            element={<SeriesSteps />}
          />
          <Route path="/colecao-novo/" element={<CollectionStepsNew />} />
          <Route
            path="/colecao-novo/:id/:version/:action?"
            element={<CollectionStepsNew />}
          />
          <Route
            path="/palavras_chave"
            element={
              <MainLayout>
                <Keywords />
              </MainLayout>
            }
          />
          {/* Channel route */}
          <Route
            path="/videos"
            element={
              <MainLayout>
                <VideosHome />
              </MainLayout>
            }
          />
          <Route
            path="/relatorios"
            element={
              <MainLayout>
                <ReportsHome />
              </MainLayout>
            }
          />
          <Route
            path="/series"
            element={
              <MainLayout>
                <SeriesHome />
              </MainLayout>
            }
          />
          <Route
            path="/colecoes-novo"
            element={
              <MainLayout>
                <CollectionsHomeNew />
              </MainLayout>
            }
          />
          <Route
            path="/colecoes-novo-antigo"
            element={
              <MainLayout>
                <CollectionsNew />
              </MainLayout>
            }
          />

          <Route
            path="/videosantigo"
            element={
              <MainLayout>
                <Videos />
              </MainLayout>
            }
          />

          <Route
            path="/upload-video/:id/:version/:action?"
            element={<VideosSteps />}
          />
          <Route path="/upload-video/" element={<VideosSteps />} />

          {/* Upload thumbnail route (POC)*/}
          <Route
            path="/thumbnails"
            element={
              <MainLayout>
                <Thumbnails />
              </MainLayout>
            }
          />
          <Route
            path="/aplicativo"
            element={
              <MainLayout>
                <SetupAppHome />
              </MainLayout>
            }
          />
        </Route>
        {/* public routes (doesnt require auth) */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/confirmLogin" element={<ConfirmLoginPage />} />
        <Route
          path="/forgotPasswordCode"
          element={<SendCodeForgotPassword />}
        />
        <Route
          path="/forgotPasswordComplete"
          element={<ForgotPasswordCompletePage />}
        />
        <Route path="/example" element={<Example />} />
      </RouterDomRoutes>
    </BrowserRouter>
  );
};
